import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSearchingResultsSucceed, EGetSearchingResultsActionType } from './types';
import { ISearchingResults } from '../../../types/searchingResults';

export const getSearchingResultsSucceed: (data: ISearchingResults) => TGetSearchingResultsSucceed = actionGenerator<
  EGetSearchingResultsActionType.Succeed,
  ISearchingResults
>(EGetSearchingResultsActionType.Succeed);
